import { useMemo } from "react";
import { IMessageType } from "./types";
import MarkdownRenderer from "../../components/MarkdownRenderer";
import TrackingTimeline from "../../components/TrackingTimeline";
import TicketConfirmation from "../../components/TicketConfirmation";

const MessageView: React.FC<{ type: IMessageType; content: string }> = ({
  type,
  content,
}) => {
  const view = useMemo(() => {
    if (type === "trackingTimeline") {
      const parsedContent = JSON.parse(content);
      return (
        <TrackingTimeline
          summary={parsedContent.summary}
          events={parsedContent.events}
        />
      );
    }
    if (type === "ticketConfirmation") {
      const parsedContent = JSON.parse(content);
      return <TicketConfirmation data={parsedContent} />;
    }
    return <MarkdownRenderer markdown={content} />;
  }, [type, content]);
  return <>{view}</>;
};

export default MessageView;
